module.exports = __webpack_public_path__ + "static/media/horse.1ad5aa74.png";